module.exports = __webpack_public_path__ + "static/media/expressjs-logo.d638bd34.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skills/skill-images/expressjs-logo.png
// module id = 249
// module chunks = 0